export interface Product {
  id: string;
  name: string;
  brand: string;
  category: 'smartphones' | 'led-tvs' | 'accessories' | 'appliances';
  price: number;
  originalPrice: number;
  discount: number;
  image: string;
  images: string[];
  rating: number;
  reviews: number;
  description: string;
  specs: Record<string, string>;
  inStock: boolean;
  isFlashSale?: boolean;
  isFeatured?: boolean;
}

export const products: Product[] = [
  {
    id: "1",
    name: "Samsung Galaxy S24 Ultra",
    brand: "Samsung",
    category: "smartphones",
    price: 129999,
    originalPrice: 144999,
    discount: 10,
    image: "https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=600&h=600&fit=crop",
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&h=600&fit=crop",
    ],
    rating: 4.8,
    reviews: 2456,
    description: "The ultimate Galaxy experience with S Pen, 200MP camera, and Titanium frame.",
    specs: { Display: "6.8\" QHD+ Dynamic AMOLED", Processor: "Snapdragon 8 Gen 3", RAM: "12GB", Storage: "256GB", Battery: "5000mAh", Camera: "200MP + 12MP + 50MP + 10MP" },
    inStock: true,
    isFeatured: true,
    isFlashSale: true,
  },
  {
    id: "2",
    name: "iPhone 15 Pro Max",
    brand: "Apple",
    category: "smartphones",
    price: 159900,
    originalPrice: 169900,
    discount: 6,
    image: "https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=600&h=600&fit=crop",
      "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=600&h=600&fit=crop",
    ],
    rating: 4.9,
    reviews: 3120,
    description: "Titanium design, A17 Pro chip, and the most powerful iPhone camera system ever.",
    specs: { Display: "6.7\" Super Retina XDR OLED", Processor: "A17 Pro", RAM: "8GB", Storage: "256GB", Battery: "4441mAh", Camera: "48MP + 12MP + 12MP" },
    inStock: true,
    isFeatured: true,
  },
  {
    id: "3",
    name: "OnePlus 12",
    brand: "OnePlus",
    category: "smartphones",
    price: 64999,
    originalPrice: 69999,
    discount: 7,
    image: "https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=600&h=600&fit=crop",
    ],
    rating: 4.6,
    reviews: 1890,
    description: "Flagship killer with Snapdragon 8 Gen 3, Hasselblad cameras, and 100W charging.",
    specs: { Display: "6.82\" QHD+ LTPO AMOLED", Processor: "Snapdragon 8 Gen 3", RAM: "12GB", Storage: "256GB", Battery: "5400mAh", Camera: "50MP + 48MP + 64MP" },
    inStock: true,
    isFeatured: true,
  },
  {
    id: "4",
    name: "Xiaomi 14 Pro",
    brand: "Xiaomi",
    category: "smartphones",
    price: 49999,
    originalPrice: 59999,
    discount: 17,
    image: "https://images.unsplash.com/photo-1546054454-aa26e2b734c7?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1546054454-aa26e2b734c7?w=600&h=600&fit=crop",
    ],
    rating: 4.5,
    reviews: 980,
    description: "Leica optics, Snapdragon 8 Gen 3, and a stunning curved display.",
    specs: { Display: "6.73\" LTPO AMOLED", Processor: "Snapdragon 8 Gen 3", RAM: "12GB", Storage: "256GB", Battery: "4880mAh", Camera: "50MP Leica + 50MP + 50MP" },
    inStock: true,
    isFlashSale: true,
  },
  {
    id: "5",
    name: "Samsung 55\" Crystal 4K UHD TV",
    brand: "Samsung",
    category: "led-tvs",
    price: 42990,
    originalPrice: 54990,
    discount: 22,
    image: "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=600&h=600&fit=crop",
    ],
    rating: 4.4,
    reviews: 1560,
    description: "Crystal clear 4K picture with vivid colors and smart TV features.",
    specs: { "Screen Size": "55 inches", Resolution: "3840 x 2160 (4K UHD)", "Panel Type": "LED", "Smart TV": "Tizen OS", Speakers: "20W", HDMI: "3 Ports" },
    inStock: true,
    isFeatured: true,
    isFlashSale: true,
  },
  {
    id: "6",
    name: "LG 43\" Full HD Smart TV",
    brand: "LG",
    category: "led-tvs",
    price: 27990,
    originalPrice: 34990,
    discount: 20,
    image: "https://images.unsplash.com/photo-1461151304267-38535e780c79?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1461151304267-38535e780c79?w=600&h=600&fit=crop",
    ],
    rating: 4.3,
    reviews: 890,
    description: "Full HD clarity with webOS smart platform and AI Sound.",
    specs: { "Screen Size": "43 inches", Resolution: "1920 x 1080 (Full HD)", "Panel Type": "IPS", "Smart TV": "webOS", Speakers: "20W", HDMI: "2 Ports" },
    inStock: true,
  },
  {
    id: "7",
    name: "boAt Airdopes 141",
    brand: "boAt",
    category: "accessories",
    price: 1299,
    originalPrice: 2990,
    discount: 57,
    image: "https://images.unsplash.com/photo-1590658268037-6bf12f032f55?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1590658268037-6bf12f032f55?w=600&h=600&fit=crop",
    ],
    rating: 4.1,
    reviews: 45600,
    description: "True wireless earbuds with 42H playtime, ENx™ Technology, and IWP™.",
    specs: { Type: "TWS Earbuds", "Battery Life": "42 Hours (total)", Driver: "8mm", Bluetooth: "5.1", "Water Resistance": "IPX4", Mic: "ENx™ Quad Mic" },
    inStock: true,
    isFeatured: true,
    isFlashSale: true,
  },
  {
    id: "8",
    name: "Samsung 20000mAh Power Bank",
    brand: "Samsung",
    category: "accessories",
    price: 2499,
    originalPrice: 3999,
    discount: 37,
    image: "https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=600&h=600&fit=crop",
    ],
    rating: 4.5,
    reviews: 2340,
    description: "25W Super Fast Charging power bank with USB-C and dual USB ports.",
    specs: { Capacity: "20000mAh", Input: "USB-C", Output: "USB-C + USB-A x2", "Fast Charging": "25W PD", Weight: "370g", Warranty: "1 Year" },
    inStock: true,
  },
  {
    id: "9",
    name: "Havells 1.5 Ton 5 Star Split AC",
    brand: "Havells",
    category: "appliances",
    price: 38990,
    originalPrice: 49990,
    discount: 22,
    image: "https://images.unsplash.com/photo-1585338107529-13afc25c9b1a?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1585338107529-13afc25c9b1a?w=600&h=600&fit=crop",
    ],
    rating: 4.3,
    reviews: 456,
    description: "Energy efficient 5 star inverter AC with copper condenser and PM 2.5 filter.",
    specs: { Capacity: "1.5 Ton", "Star Rating": "5 Star", Type: "Split Inverter", Refrigerant: "R32", Condenser: "Copper", Warranty: "5 Years Compressor" },
    inStock: true,
    isFeatured: true,
  },
  {
    id: "10",
    name: "Realme Narzo 70x 5G",
    brand: "Realme",
    category: "smartphones",
    price: 11999,
    originalPrice: 14999,
    discount: 20,
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&h=600&fit=crop",
    ],
    rating: 4.2,
    reviews: 3450,
    description: "Budget 5G smartphone with 50MP AI camera and 5000mAh battery.",
    specs: { Display: "6.72\" FHD+ IPS LCD", Processor: "Dimensity 6100+", RAM: "6GB", Storage: "128GB", Battery: "5000mAh", Camera: "50MP + 2MP" },
    inStock: true,
    isFlashSale: true,
  },
  {
    id: "11",
    name: "JBL Flip 6 Bluetooth Speaker",
    brand: "JBL",
    category: "accessories",
    price: 9999,
    originalPrice: 14999,
    discount: 33,
    image: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=600&h=600&fit=crop",
    ],
    rating: 4.6,
    reviews: 5670,
    description: "Portable waterproof Bluetooth speaker with powerful JBL Pro Sound.",
    specs: { Type: "Portable Speaker", "Battery Life": "12 Hours", "Water Resistance": "IP67", Bluetooth: "5.1", Output: "30W", Weight: "550g" },
    inStock: true,
    isFeatured: true,
  },
  {
    id: "12",
    name: "Bajaj 750W Mixer Grinder",
    brand: "Bajaj",
    category: "appliances",
    price: 3499,
    originalPrice: 4999,
    discount: 30,
    image: "https://images.unsplash.com/photo-1570222094114-d054a817e56b?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1570222094114-d054a817e56b?w=600&h=600&fit=crop",
    ],
    rating: 4.2,
    reviews: 8900,
    description: "Powerful 750W motor mixer grinder with 3 stainless steel jars.",
    specs: { Power: "750W", Jars: "3 (Liquidising, Dry Grinding, Chutney)", Speed: "3 Speed + Pulse", Blades: "Stainless Steel", Warranty: "2 Years", Color: "White" },
    inStock: true,
  },
];

export const brands = ["Samsung", "Apple", "OnePlus", "Xiaomi", "Realme", "boAt", "JBL", "LG", "Havells", "Bajaj", "Vivo", "OPPO", "Nothing", "Google"];

export const categories = [
  { id: "smartphones", name: "Smartphones", icon: "Smartphone", count: 5 },
  { id: "led-tvs", name: "LED TVs", icon: "Tv", count: 2 },
  { id: "accessories", name: "Accessories", icon: "Headphones", count: 3 },
  { id: "appliances", name: "Appliances", icon: "Refrigerator", count: 2 },
] as const;

export type Category = typeof categories[number]['id'];
